import { Chip as MuiChip } from '@mui/material'

import { CustomInsightStatus } from '../../types/CustomInsight'

type CopyObject = {
  [key: string]: string
}

interface ChipProps {
  copy: CopyObject
  status: CustomInsightStatus
}

export const StatusChip: React.FC<ChipProps> = ({ copy, status }) => {
  let label = copy.active_tab
  let bgColor = 'success.100'
  let textColor = 'success.700'

  switch (status) {
    case CustomInsightStatus.Pending:
      label = copy.pending_tab
      bgColor = 'grey.100'
      textColor = 'grey.900'
      break

    case CustomInsightStatus.Disabled:
      label = copy.disabled_tab
      bgColor = 'error.100'
      textColor = 'error.700'
      break

    default:
      break
  }

  return (
    <MuiChip
      label={label}
      size="small"
      sx={{
        backgroundColor: bgColor,
        color: textColor,
        fontSize: 9,
        fontWeight: 'bold',
        height: 16,
        textTransform: 'uppercase',
      }}
    />
  )
}
